/** MapLibre layer id for the incident heatmap; kept standalone so the layer-ordering service can
 * reference it without importing the map service (which would create a circular dependency). */
export const INCIDENT_HEATMAP_LAYER_ID = 'incident-heatmap';
